<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <div>
      <div class="row justify-content-center">
        <div class="col-8">
          <div class="row justify-content-center">
            <h3>Thank you, your application has been completed. Your application number is: {{applicationNumber}}</h3>
          </div>

          <p>
            Thank you for using the Cook County Department of Environment &amp; Sustainability on-line report
            system. After approval of your application by the department, it will be emailed to the address you
            provided with your application.
          </p>
          <dl class="row">
            <dt class="col-12">For Customer Service:</dt>
            <dt class="col-sm-3">Hours:</dt>
            <dd class="col-sm-9">8:30am - 4:30pm</dd>
            <dt class="col-sm-3">Phone:</dt>
            <dd class="col-sm-9">(312) 603-8200 (and follow appropriate prompt)</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput';
import { submitOpenBurnNoFeeApplication, validatePermitNumber } from '@/js/FormFunctions';

import { CapitalizeFilter } from '@/js/Mixins';

export default {
  name: 'OpenBurnApplicationThankYouNoFee',
  components: { BaseInput },
  mixins: [CapitalizeFilter],
  data() {
    return {
      applicationNumber: null,
      fetchingData: true,
    };
  },
  mounted() {
    this.applicationNumber = this.$route.params.applicationNumber;
    this.fetchingData = false;
  },
};
</script>
